import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  imports: [RouterLink],
})
export class VerifyEmailComponent implements OnInit {
  loading = true;
  success = false;
  errorMessage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');

    if (!code) {
      this.loading = false;
      this.errorMessage = 'Verification code is missing.';
      return;
    }

    this.authService.verifyEmail(code).subscribe({
      next: () => {
        this.loading = false;
        this.success = true;

        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2500);
      },
      error: () => {
        this.loading = false;
        this.success = false;
        this.errorMessage = 'Verification failed or the code has expired.';
      },
    });
  }
}
